var company = {};
module['exports'] = company;
company.prefix = require("./prefix");
company.name = require("./name");
